<template>
  <div
    class="container"
    @keydown.esc="displayPreview = false"
  >
    <div class="row">
      <div class="col-12">
        <div class="media-library">
          <div class="listagem-filter">
            <ul v-if="!disableMenu">
              <media-library-filter :button-text="state.i18n.buttonText" />
            </ul>
            <media-library-filter-type>
              <h4
                :key="selectTypeLabelKey"
                :name="selectTypeLabelSlotName"
                class="label"
              >
                <slot :name="selectTypeLabelSlotName" />
              </h4>
              <a
                :key="allLabelKey"
                :name="allLabelSlotName"
                class="allFilter"
                :class="{'active_allFilter': getTypeFiltro() }"
                @click="allFilter()"
              >
                <slot :name="allLabelSlotName" />
              </a>
            </media-library-filter-type>
          </div>
          <div class="listagem-result">
            <media-library-item />
          </div>
          <paginator
            v-if="state.total"
            v-model="current"
            :i18n="state.i18n"
            :total="state.total"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  mapGetters, mapActions, mapMutations, mapState
} from 'vuex'
import MediaLibraryFilter from './media-library-filter.vue'
import MediaLibraryItem from './media-library-item.vue'
import MediaLibraryFilterType from './media-library-filter-type.vue'
import Paginator from './paginator.vue'

export default {
  name: 'media-library',
  components: {
    MediaLibraryFilter,
    MediaLibraryItem,
    MediaLibraryFilterType,
    Paginator,
  },
  props: {
    parentid: {
      type: String
    },
    disableMenu: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      displayPreview: false,
      pdfPreviewUrl: null,
      selectTypeLabelKey: 0,
      selectTypeLabelSlotName: 'select-type-label-container',
      allLabelKey: 1,
      allLabelSlotName: 'all-label-container'
    }
  },
  computed: {
    ...mapState({
      state: state => state.mediaStore
    }),
    current: {
      get() {
        return this.$store.state.mediaStore.current
      },
      set(current) {
        this.paginate(current)
      }
    },
    ...mapGetters({
      getMediaLibrary: 'getMediaLibrary',
      getMediaLibraryCategoria: 'getMediaLibraryCategoria',
      getMediaLibraryTypes: 'getMediaLibraryTypes',
      getTypeFiltro: 'getTypeFiltro'
    })
  },
  created() {
    this.$store.commit('initialize', {
      parentid: this.parentid,
      i18n: {
        buttonText: 'All',
        paginatorPrevious: 'Previous',
        paginatorNext: 'Next'
      }
    })
  },
  mounted() {
    this.search()
  },
  methods: {
    ...mapActions({
      search: 'search',
      paginate: 'paginate'
    }),
    ...mapMutations({
      setTypeFiltro: 'setTypeFiltro'
    }),
    allFilter() {
      this.setTypeFiltro('')
    }
  },
}
</script>
